import React, { Fragment, useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';
import './CaseSummary.scss';
import { Row, Col, Accordion } from "react-bootstrap";
import { CaseFormField } from "../../CaseGenerator";
import { getChaptersFromLayout } from "../../../../helpers";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

const CaseSummary = (props) => {
  const {
    layout,
    fields,
    setSummaryModalVisible,
    setSummaryEditingLayout,
    dataToUpdate,
    setDataToUpdate,
    setActiveStep,
    setIsSummary
  } = props;

  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  const editSection = (absId, values, index) => {
    console.log('should edit section #' + index);
    setSummaryEditingLayout(layout[absId], values, index, absId);
    setSummaryModalVisible(true);
  };

  useEffect(() => {
    if (!dataToUpdate) return;
    Object.keys(dataToUpdate).forEach(key => {
      setFieldValue(key, dataToUpdate[key]);
    });
    setDataToUpdate(null);
    // eslint-disable-next-line
  }, [dataToUpdate]);

  const isConditionMet = (conditionProps) => {
    if (!conditionProps) return true;
    const conditions = conditionProps;
    if (conditions.length === 0) return true;
    let allowed = false;
    if (Array.isArray(conditions)) {
      conditions.forEach(condition => {
        if (values[condition.if] === condition.is) {
          allowed = true;
        }
      });
    } else {
      return true;
    }
    return allowed;
  };

  const handleConditionSummaryProps = (conditionSummaryProps) => {
    if (conditionSummaryProps !== undefined) {
      return conditionSummaryProps;
    } else {
      return true;
    }
  };

  const chapters = getChaptersFromLayout(layout);
  // Map initial aria-expanded values
  const [ariaExpandedStates, setExpandedStates] = useState(() =>
    chapters.map(() => true)
  );
  // Update aria-expanded values
  const updateExpandedState = (index, newValue) => {
    setExpandedStates(prev => {
      const updated = [...prev];
      updated[index] = newValue;
      return updated;
    });
  };

  return (
    <div className="CaseSummary" data-testid="CaseSummary">
      <div className="caseSummary-title">
        <h2 className='headline-bold-fs2'>{t("summary-title")}</h2>
        <p className='headline-fs5'>{t("summary-description")}</p>
      </div>

      {chapters.map((chapter, index) => {
        const eventKey = `Chapter${index}`;
        const headerId = `acc-header-${index}`;
        const panelId  = `acc-panel-${index}`;
        const isExpanded = ariaExpandedStates[index];

        return (
          <Accordion
            key={`accordion Chapter${index}--accordion`}
            defaultActiveKey={eventKey}
            onSelect={() => updateExpandedState(index, !isExpanded)}
          >
            <Accordion.Toggle
              key={`accordion-${eventKey}`} 
              className={`accordion-header headline-bold-fs4 ${isExpanded ? 'open' : ''}`} 
              as="h2" 
              eventKey={eventKey}
            >
              <button
                id={headerId}
                type="button"
                className="accordion-header-button headline-bold-fs4"
                aria-expanded={isExpanded}
                aria-controls={panelId}
              >
                {chapter.chapterName}
              </button>
            </Accordion.Toggle>
            <div 
              id={panelId}
              className='accordion-body-container'
              role="region"
              aria-labelledby={headerId}
              aria-hidden={!isExpanded}
            >
              <Accordion.Collapse
                eventKey={eventKey}
              >
                <div className='accordion-body'>
                  {chapter.subchapters.map((layoutItem, layoutItemIndex) => (
                    <Fragment key={`layout-item${index}_${layoutItemIndex}`}>
                      <div className='accordion-body-item' tabIndex={0}>
                        <div className="accordion-body-item-header">
                          <h4 className='headline-fs6'>
                            {layoutItem.title}
                          </h4>
                          {layoutItem.noModify ? null : (
                            <button
                              type="button"
                              className="btn-reset paragraph-main-fs8"
                              aria-label={`${t("cases.summary.modify")}[${renderToString(layoutItem.title)}]`}
                              onClick={
                                layoutItem.noSummaryModal
                                  ? () => {
                                      if (layoutItem.onModify) {
                                        layoutItem.onModify(setFieldValue);
                                      }
                                      setActiveStep(
                                        layoutItem.summaryCustomActiveStep
                                          ? layoutItem.absId + layoutItem.summaryCustomActiveStep
                                          : layoutItem.absId
                                      );
                                      setIsSummary(false);
                                    }
                                  : () => editSection(layoutItem.absId, values, index)
                              }
                            >
                              {t("cases.summary.modify")}
                            </button>
                            
                          )}
                        </div>
                        <Row className="accordion-body-item-content">
                          {layoutItem.fields
                            .filter(field => handleConditionSummaryProps(field.summaryCondition))
                            .map((field, fieldIndex) => {
                              const conditionProps = field.condition || null;
                              const conditionMet = isConditionMet(conditionProps);
                              if (!field.fieldName) return null;
                                
                              const fieldProps = fields[field.fieldName];
                              const { summaryView = true, privacyMode = false } = fieldProps;

                              return summaryView && conditionMet && (
                                <Col key={`item${fieldIndex}`} sm={6} md={4} lg={3}>
                                  <CaseFormField {...fieldProps} summaryMode={true} isCaseSummaryStep={true} />
                                </Col>
                              );
                            })}
                        </Row>
                      </div>
                    </Fragment>
                  ))}
                </div>
            </Accordion.Collapse>
            </div>
            
          </Accordion>
        );
      })}
    </div>
  );
};

// this solves continuous re-rendering for component
export default CaseSummary;
